/**
 * @generated SignedSource<<9a27e7af3e7e7f07acbca702ea9b8ca0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MailingListList_query$data = {
  readonly mailingLists: ReadonlyArray<{
    readonly archivedAt: any | null | undefined;
    readonly createdAt: any;
    readonly description: string;
    readonly id: string;
    readonly mailingListIdentifier: string;
    readonly name: string;
    readonly subscribedCount: number;
    readonly unsubscribedCount: number;
  }>;
  readonly " $fragmentType": "MailingListList_query";
};
export type MailingListList_query$key = {
  readonly " $data"?: MailingListList_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"MailingListList_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MailingListList_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MailingList",
      "kind": "LinkedField",
      "name": "mailingLists",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mailingListIdentifier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subscribedCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unsubscribedCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "archivedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "13f403a76cf609c928fa7592eea70765";

export default node;
